// src/components/pages/mypage/partials/ProfileAboutTab.js

import React from 'react';
import DOMPurify from 'dompurify';
import { useTranslation, Trans } from 'react-i18next';
import styles from '../style/MyPage.module.css';

// DEFAULT_PROFILE_URL은 MyPage.js에서 props로 받거나 여기서 다시 정의해야 합니다.
// 여기서는 MyPage.js의 환경 변수 선언을 그대로 복사해 온다고 가정합니다.
const DEFAULT_PROFILE_URL = process.env.REACT_APP_DEFAULT_PROFILE_IMAGE;

export default function ProfileAboutTab({
  nickname,
  introduction,
  profileImageUrl,
  loading,
  loadingFollows,
  followingList,
  followerList,
  fileInputRef,
  handleImageClick,
  handleProfileImageUpload,
  setShowEditNicknameModal,
  setShowEditIntroductionModal,
  handleOpenFollowListModal,
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.tabContent}>
      {/* 프로필 요약 섹션 */}
      <section className={styles.profileSummaryCard}>
        <div className={styles.profileHeader}>
          {/* 프로필 이미지 영역 */}
          <div className={styles.profileAvatar} onClick={handleImageClick}>
            {loading ? (
              <div className={styles.loading}>...</div>
            ) : (
              <>
                <img
                  src={profileImageUrl || DEFAULT_PROFILE_URL}
                  alt="Profile"
                  className={styles.profileImage}
                />
                <div className={styles.imageOverlay}>
                  <span className={styles.overlayText}></span>
                </div>
              </>
            )}
          </div>
          <input 
            type="file" 
            ref={fileInputRef} 
            onChange={handleProfileImageUpload} 
            style={{ display: 'none' }} 
            accept="image/*"
          />
          {/* 텍스트 내용 */}
          <div className={styles.profileTextContent}>
            <div className={styles.nicknameContainer}>
              <h2 
                className={styles.profileNickname}
                onClick={() => setShowEditNicknameModal(true)}
              >
                {DOMPurify.sanitize(nickname)}
              </h2>
            </div>
            {introduction ? (
              <p
                className={styles.profileIntroduction}
                onClick={() => setShowEditIntroductionModal(true)}
              >
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(introduction) }} />
              </p>
            ) : (
              <div className={styles.onboardingSection}>
                <h3>{t('mypage.onboardingTitle')}</h3>
                <p className={styles.onboardingText}>
                  <Trans i18nKey="mypage.onboardingText" components={{ 1: <strong /> }} />
                </p>
                <button
                  onClick={() => setShowEditIntroductionModal(true)}
                  className={styles.onboardingButton}
                >
                  {t('mypage.getStarted')}
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 활동 통계 섹션 */}
      <section className={styles.activityMetrics}>
        {loadingFollows ? (
          <p className={styles.loading}>{t('mypage.loadingFollows')}</p>
        ) : (
          <div className={styles.metricsGrid}>
            <div
              className={styles.metricItem}
              onClick={() => handleOpenFollowListModal('following')}
            >
              <span className={styles.metricIcon}>➡️</span>
              <span className={styles.metricValue}>{followingList.length}</span>
              <span className={styles.metricLabel}>{t('mypage.following')}</span>
            </div>
            <div
              className={styles.metricItem}
              onClick={() => handleOpenFollowListModal('followers')}
            >
              <span className={styles.metricIcon}>⬅️</span>
              <span className={styles.metricValue}>{followerList.length}</span>
              <span className={styles.metricLabel}>{t('mypage.followers')}</span>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}